// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"92a36669","703":"453ccaf4","787":"e449a12e"}[chunkId] + ".chunk.js";
};